const matchesLaneContactSearch = (ticket, query) => {
  const trimmed = (query || "").trim();
  if (!trimmed) return true;

  const needle = trimmed.toLowerCase();
  const contactName = (ticket?.contact?.name || "").toLowerCase();
  const contactNumber = ticket?.contact?.number || "";
  const contactNumberDigits = contactNumber.replace(/\D/g, "");
  const needleDigits = trimmed.replace(/\D/g, "");

  if (contactName.includes(needle)) return true;
  if (contactNumber.toLowerCase().includes(needle)) return true;
  if (needleDigits && contactNumberDigits.includes(needleDigits)) return true;

  return false;
};

export default matchesLaneContactSearch;
